/* ===== YesAgain theme global JS ===== */
(function(){
  const R = window.routes || {};
  const S = window.YA_STR || {};
  const CFG = Object.assign({uvFlag:true,uvClick:true,ulFlag:true,ulClick:true}, window.YA_CFG||{});
  // Format in the market's presentment currency (Shopify Markets) — AED, SAR, … picked up naturally.
  const money = v => {
    const cur = window.YA_CURRENCY || 'AED';
    try { return new Intl.NumberFormat('en', { style:'currency', currency: cur, minimumFractionDigits:0, maximumFractionDigits:2 }).format(v/100); }
    catch(_) { return cur+' '+(v/100).toLocaleString('en'); }
  };

  /* hero slideshow */
  function initSlideshow(){
    const slides=[...document.querySelectorAll('.slide')], dots=[...document.querySelectorAll('#dots span')];
    if(slides.length<2) return; let cur=0, timer;
    const go=i=>{ slides[cur].classList.remove('is-active'); dots[cur]&&dots[cur].classList.remove('on');
      cur=(i+slides.length)%slides.length; slides[cur].classList.add('is-active'); dots[cur]&&dots[cur].classList.add('on'); };
    const auto=()=> timer=setInterval(()=>go(cur+1),6000);
    dots.forEach((d,i)=>d.onclick=()=>{clearInterval(timer);go(i);auto();}); auto();
  }

  /* mobile drawer */
  function initDrawer(){
    const d=document.getElementById('drawer'), b=document.getElementById('burger');
    if(b&&d){ b.onclick=()=>d.classList.add('open'); d.querySelectorAll('[data-close]').forEach(e=>e.onclick=()=>d.classList.remove('open')); }
  }

  /* FAQ accordion */
  function initFAQ(){ document.querySelectorAll('.qa__q').forEach(q=>q.onclick=()=>{
    const qa=q.closest('.qa'), a=qa.querySelector('.qa__a'), open=qa.classList.toggle('open');
    a.style.maxHeight = open ? a.scrollHeight+'px' : 0; }); }

  /* ===== CART (Shopify AJAX) ===== */
  function variantLine(it){ return it.product_has_only_default_variant ? '' : (it.variant_title || ''); }
  function esc(s){ return String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c])); }
  // Shopify /cart.js gives properties as an object; Liquid `properties | json` gives an array of
  // [key,value] pairs. Normalise both to a plain object.
  function normProps(props){
    if(!props) return {};
    if(Array.isArray(props)){ const o={}; props.forEach(p=>{ if(Array.isArray(p)&&p.length>=2) o[p[0]]=p[1]; }); return o; }
    return props;
  }
  // Map Globo cart-label -> {hidden} from window.GPOConfigs (recurse into group elements).
  function gpoFieldMap(){
    const map={};
    try{
      const opts=(window.GPOConfigs&&window.GPOConfigs.options)||{};
      const walk=els=>{ if(!Array.isArray(els)) return;
        els.forEach(el=>{ if(el && el.type==='group'){ walk(el.elements); return; }
          if(el && el.label_on_cart) map[el.label_on_cart]={hidden:!!el.hidden_label}; }); };
      for(const id in opts){ walk(opts[id] && opts[id].elements); }
    }catch(_){}
    return map;
  }
  // Build option <li> list from line-item properties; respects Globo "Hide Label" (value only).
  const OPTS_STYLE='margin:6px 0 0;padding-left:16px;list-style:disc;font-size:13px;color:var(--ink3);line-height:1.55';
  function gpoOptList(props){
    props=normProps(props); if(!props) return [];
    const map=gpoFieldMap(); const out=[];
    for(const k in props){ const v=props[k];
      if(!v || k.charAt(0)==='_' || String(k).indexOf('default-')>=0) continue;
      const f=map[k];
      if(f && f.hidden){ out.push(esc(v)); continue; }          // Hide Label → value only
      const cap=k.charAt(0).toUpperCase()+k.slice(1);
      out.push(String(k).toLowerCase().trim()===String(v).toLowerCase().trim() ? esc(cap) : esc(cap)+': '+esc(v));
    }
    return out;
  }
  function propsLine(it){
    const items=gpoOptList(it.properties);
    return items.length ? `<ul class="citem__opts" style="${OPTS_STYLE}">${items.map(x=>`<li>${x}</li>`).join('')}</ul>` : '';
  }
  // Cart page: fill each option list from data-gpo-props (needs GPOConfigs for Hide Label).
  function initCartPageOpts(){
    document.querySelectorAll('[data-gpo-props]').forEach(el=>{
      let props; try{ props=JSON.parse(el.getAttribute('data-gpo-props')); }catch(_){ el.remove(); return; }
      const items=gpoOptList(props);
      if(items.length){ el.innerHTML=items.map(x=>`<li>${x}</li>`).join(''); }
      else { el.remove(); }
    });
  }
  // Cart PAGE qty +/- and remove (own attrs so the drawer's [data-qty-*]/[data-rm] delegation
  // doesn't fire here). Removing a parent also removes its Globo add-on children.
  async function cartUpdate(updates){
    try{ await fetch((R.cart_url||'/cart')+'/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:updates})}); }catch(_){}
    location.reload();
  }
  function initCartPage(){
    const root=document.querySelector('form.checkout'); if(!root) return;
    root.addEventListener('click',e=>{
      const up=e.target.closest('[data-cart-up]'), dn=e.target.closest('[data-cart-down]'), rm=e.target.closest('[data-cart-rm]');
      if(!up && !dn && !rm) return;
      e.preventDefault();
      const card=(up||dn||rm).closest('[data-key]'); if(!card) return;
      const key=card.getAttribute('data-key');
      const valEl=card.querySelector('[data-qty-val]'); const cur=parseInt(valEl?valEl.textContent:'1',10)||1;
      const updates={};
      if(rm){
        updates[key]=0;
        const grp=card.getAttribute('data-grp');
        if(grp){ document.querySelectorAll('[data-parent-grp]').forEach(ch=>{ if(ch.getAttribute('data-parent-grp')===grp){ const ck=ch.getAttribute('data-childkey'); if(ck) updates[ck]=0; } }); }
      } else if(up){
        const max=parseInt(card.getAttribute('data-max'),10);
        if(!isNaN(max) && cur>=max){ toast(max<=1 ? (S.only_one_left||'Only 1 in stock — this renewed unit is one of a kind.') : (S.only_n_available||'Only {n} available in stock for this item.').replace('{n}',max)); return; }
        updates[key]=cur+1;
      } else { updates[key]=cur-1; } // minus past 1 → 0 removes the line
      cartUpdate(updates);
    });
  }
  // True when a Globo add-on PRODUCT is currently selected (carries gpo-data-variant-id).
  function globoAddonSelected(form){
    for(const el of form.querySelectorAll('input[gpo-data-variant-id]')){
      if((el.type==='checkbox'||el.type==='radio') && el.checked) return true; }
    for(const sel of form.querySelectorAll('select')){
      const opt=sel.selectedOptions && sel.selectedOptions[0];
      if(opt && opt.getAttribute('gpo-data-variant-id')) return true; }
    return false;
  }
  // True when a Globo "Add Price" option (surcharge via Cart Transform, no linked variant) is selected.
  // Globo must own the submit for these too. It mirrors a selected priced option into a hidden
  // properties[...] input carrying data-addon-price — that mirror is the reliable signal.
  function globoPricedOptionSelected(form){
    for(const el of form.querySelectorAll('input[type="hidden"][data-addon-price]')){
      if((parseFloat(el.getAttribute('data-addon-price'))||0)>0 && el.value) return true; }
    for(const el of form.querySelectorAll('[data-addon-price]')){
      const p=parseFloat(el.getAttribute('data-addon-price'))||0; if(p<=0) continue;
      if((el.type==='checkbox'||el.type==='radio') && el.checked) return true;
      if(el.tagName==='OPTION' && el.selected) return true; }
    return false;
  }
  function renderCartBody(cart){
    const body=document.getElementById('cartItems'); if(!body) return;
    if(!cart.item_count){ body.innerHTML='<div class="cartempty"><p>'+(S.cart_empty||'Your cart is empty.')+'</p><a class="btn btn--amber" href="/collections/all">'+(S.shop_devices||'Shop devices')+'</a></div>';
      const f=document.getElementById('cartFoot'); if(f) f.style.display='none'; return; }
    const f=document.getElementById('cartFoot'); if(f) f.style.display='';
    body.innerHTML=cart.items.map(it=>`<div class="citem">
      <div class="citem__img"><img src="${((it.handle&&it.handle.indexOf('battery')>=0)||!it.image) ? ((window.YA_ASSETS&&window.YA_ASSETS.battery)||'') : it.image.replace(/(\.[a-z]+)(\?|$)/i,'_140x$1$2')}" alt=""></div>
      <div class="citem__b"><div class="citem__top"><div class="citem__n">${it.product_title}</div><button class="citem__rm" data-rm="${it.key}" aria-label="${S.remove||'Remove'}">✕</button></div>
        ${variantLine(it)?`<div class="citem__v">${variantLine(it)}</div>`:''}
        ${propsLine(it)}
        <div class="citem__bot"><div class="qty"><button data-qty-down="${it.key}">–</button><span>${it.quantity}</span><button data-qty-up="${it.key}">+</button></div>
        <div class="citem__p">${money(it.final_line_price)}</div></div></div></div>`).join('');
    const sub=document.getElementById('cartSub'); if(sub) sub.textContent=money(cart.total_price);
    const c2=document.getElementById('cartCount2'); if(c2) c2.textContent=cart.item_count?`(${cart.item_count})`:'';
  }
  function setBadge(n){ const b=document.getElementById('cartBadge'); if(b){ b.textContent=n; b.hidden=n===0; } }
  async function refreshCart(open){
    const r=await fetch(R.cart_url+'.js',{headers:{'Accept':'application/json'}}); const cart=await r.json();
    if(cart && cart.currency) window.YA_CURRENCY=cart.currency;  // sync the drawer's money() to the cart's real presentment currency (Shopify Markets) — fixes stale-currency flicker after a country/currency switch without reload
    const q={}; (cart.items||[]).forEach(it=>{ q[it.id]=(q[it.id]||0)+it.quantity; }); window.__yaCartQ=q;
    setBadge(cart.item_count); renderCartBody(cart);
    if(window.yaSyncPDP) window.yaSyncPDP();   // keep the PDP buy button in sync with cart quantities
    if(open){ const cd=document.getElementById('cartdrawer'); if(cd) cd.classList.add('open'); }
  }
  // bfcache: pages restored via the browser Back button don't re-run scripts — re-sync cart state
  window.addEventListener('pageshow',e=>{ if(e.persisted){ refreshCart(false); } });
  function toast(msg){
    let t=document.getElementById('yaToast');
    if(!t){ t=document.createElement('div'); t.id='yaToast'; t.className='ya-toast'; document.body.appendChild(t); }
    t.textContent=msg; t.classList.add('show');
    clearTimeout(t._h); t._h=setTimeout(()=>t.classList.remove('show'),3800);
  }
  window.addItems = async function(items){
    const r=await fetch(R.cart_add_url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});
    if(!r.ok){
      const e=await r.json().catch(()=>({}));
      const msg = e.description || e.message || (typeof e.errors==='string' ? e.errors : (e.errors && e.errors.quantity && e.errors.quantity[0])) || (S.could_not_add||'Could not add to cart.');
      // refurbished units are unique (stock 1): if it's already in the cart, say so + open the drawer
      if(/maximum quantity|already in your cart/i.test(msg)){ toast(S.already_in_cart||'Already in your cart — this renewed unit is one of a kind (limited stock).'); refreshCart(true); return; }
      toast(msg); return;
    }
    await refreshCart(true);
  };
  window.addToCartById = function(variantId, qty){ return window.addItems([{id:variantId,quantity:qty||1}]); };
  async function changeLine(key, qty){
    await fetch(R.cart_change_url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})});
    await refreshCart(false);
  }
  function initCart(){
    const cd=document.getElementById('cartdrawer'), btn=document.getElementById('cartBtn');
    if(btn&&cd){ btn.addEventListener('click',e=>{ e.preventDefault(); refreshCart(true); });
      cd.querySelectorAll('[data-cclose]').forEach(e=>e.onclick=()=>cd.classList.remove('open')); }
    document.addEventListener('click',e=>{
      const up=e.target.closest('[data-qty-up]'), dn=e.target.closest('[data-qty-down]'), rm=e.target.closest('[data-rm]');
      if(up){ const row=up.closest('.citem'); const q=+row.querySelector('.qty span').textContent+1; changeLine(up.dataset.qtyUp,q); }
      else if(dn){ const row=dn.closest('.citem'); const q=Math.max(0,+row.querySelector('.qty span').textContent-1); changeLine(dn.dataset.qtyDown,q); }
      else if(rm){ changeLine(rm.dataset.rm,0); }
    });
    // PDP add-to-cart forms (with optional new-battery add-on)
    document.querySelectorAll('form[data-product-form], form.ya-product-form').forEach(form=>{
      form.addEventListener('submit',e=>{
        // Globo owns the submit ONLY when an add-on PRODUCT is selected: Globo disables AJAX,
        // adds the add-on and redirects to /cart (documented Globo behaviour — no drawer possible).
        // For plain selections (or no Globo at all) we add via AJAX so our drawer opens, carrying
        // the chosen Globo option values as line-item properties.
        // Yield the submit to Globo for add-on PRODUCTS *and* "Add Price" options (surcharge).
        if(globoAddonSelected(form) || globoPricedOptionSelected(form)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        const id=form.querySelector('[name="id"]').value;
        const main={id:id,quantity:1,properties:{}};
        // carry Globo option values (data-name="properties[...]") as line-item properties
        form.querySelectorAll('[data-name^="properties["]').forEach(el=>{
          if((el.type==='checkbox'||el.type==='radio') && !el.checked) return;
          const m=(el.getAttribute('data-name')||'').match(/^properties\[([^\]]+)\]/);
          if(m && el.value!=='' && el.value!=null) main.properties[m[1]]=el.value;
        });
        if(!Object.keys(main.properties).length) delete main.properties;
        const items=[main];
        const batt=form.querySelector('#ya-battery');
        if(batt && batt.checked && batt.dataset.addonVariant){ items.push({id:batt.dataset.addonVariant,quantity:1}); }
        window.addItems(items);
      });
    });
  }

  /* ===== SEARCH (Shopify predictive) ===== */
  // Suggestion TYPES are driven by Search & Discovery: we request all of them and render
  // whatever Shopify returns (products, collections, pages, query suggestions). OOS handling
  // is left to Shopify's default (no unavailable_products override here).
  var YA_SEARCH_TYPES='query,collection,product,page';
  function yEsc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function yImg(u,sz){ return u ? String(u).replace(/(\.[a-z]+)(\?|$)/i,'_'+sz+'$1$2') : ''; }
  function ySearchGroups(j){
    var rr=(j&&j.resources&&j.resources.results)||{}, g=[];
    function im(x){ return typeof x==='string'?x:(x&&x.url)||''; }
    if(rr.queries&&rr.queries.length)         g.push({label:S.search_suggestions||'Suggestions',items:rr.queries.map(function(x){return {url:x.url,title:x.text||x.styled_text||''};})});
    if(rr.products&&rr.products.length)        g.push({label:S.search_products||'Products',items:rr.products.map(function(p){return {url:p.url,title:p.title,sub:p.product_type||p.vendor||'',image:im(p.image),price:p.price};})});
    if(rr.collections&&rr.collections.length)  g.push({label:S.search_collections||'Collections',items:rr.collections.map(function(c){return {url:c.url,title:c.title,image:im(c.image||c.featured_image)};})});
    if(rr.pages&&rr.pages.length)              g.push({label:S.search_pages||'Pages',items:rr.pages.map(function(p){return {url:p.url,title:p.title};})});
    return g;
  }
  function ySearchOverlayHTML(groups){
    return groups.map(function(g){ return '<div class="srch__lab">'+yEsc(g.label)+'</div>'+g.items.map(function(it){
      var img=it.image?'<span class="srow__img"><img src="'+yImg(it.image,'92x')+'" alt=""></span>':'';
      var price=it.price?'<span class="srow__p">'+money(parseInt(String(it.price).replace(/[^0-9]/g,''),10))+'</span>':'';
      var sub=it.sub?'<span>'+yEsc(it.sub)+'</span>':'';
      return '<a class="srow'+(it.image?'':' srow--noimg')+'" href="'+it.url+'">'+img+'<span class="srow__t"><b>'+yEsc(it.title)+'</b>'+sub+'</span>'+price+'</a>';
    }).join(''); }).join('');
  }
  function ySearchBarHTML(groups){
    return groups.map(function(g){ return '<div class="ya-searchbar__lab">'+yEsc(g.label)+'</div>'+g.items.map(function(it){
      var img=it.image?'<img src="'+yImg(it.image,'64x')+'" alt="">':'';
      var sub=it.sub?'<i>'+yEsc(it.sub)+'</i>':'';
      return '<a class="ya-searchbar__row'+(it.image?'':' ya-searchbar__row--noimg')+'" href="'+it.url+'">'+img+'<span><b>'+yEsc(it.title)+'</b>'+sub+'</span></a>';
    }).join(''); }).join('');
  }
  function initSearch(){
    const ov=document.getElementById('searchov'), btn=document.getElementById('searchBtn'),
          input=document.getElementById('searchInput'), close=document.getElementById('searchClose'), results=document.getElementById('searchResults');
    if(!ov||!btn) return;
    const open=()=>{ov.classList.add('open');document.body.style.overflow='hidden';setTimeout(()=>input.focus(),60);};
    const shut=()=>{ov.classList.remove('open');document.body.style.overflow='';};
    btn.onclick=open; if(close) close.onclick=shut;
    ov.addEventListener('click',e=>{if(e.target===ov)shut();});
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&ov.classList.contains('open'))shut();});
    let t;
    async function draw(q){
      q=q.trim();
      if(!q){ results.innerHTML='<div class="srch__lab">'+(S.search_popular||'Popular')+'</div><div class="srch__cats"><a href="/collections/iphone">iPhone</a><a href="/collections/macbook">MacBook</a><a href="/collections/ipad">iPad</a><a href="/collections/apple-watch">Apple Watch</a><a href="/collections/airpods">AirPods</a></div>'; return; }
      try{
        const u=(R.predictive_search_url||'/search/suggest')+'.json?q='+encodeURIComponent(q)+'&resources[type]='+YA_SEARCH_TYPES+'&resources[limit]=5&resources[limit_scope]=each';
        const r=await fetch(u); const j=await r.json(); const groups=ySearchGroups(j);
        if(!groups.length){ results.innerHTML=`<div class="srch__none">${(S.search_no_results||'No matches for “{{ terms }}”.').replace('{{ terms }}',q)}</div>`; return; }
        results.innerHTML=ySearchOverlayHTML(groups);
      }catch(_){ results.innerHTML='<div class="srch__none">'+(S.search_unavailable||'Search is unavailable right now.')+'</div>'; }
    }
    input.addEventListener('input',()=>{clearTimeout(t);t=setTimeout(()=>draw(input.value),140);});
  }

  /* ===== lightbox + 3D tilt ===== */
  function initLightbox(){
    const lb=document.getElementById('lightbox'); if(!lb) return; const img=lb.querySelector('img');
    const close=()=>{lb.classList.remove('open');img.classList.remove('zoomed');document.body.style.overflow='';};
    lb.addEventListener('click',e=>{ if(e.target===lb||e.target.closest('.lb__x')) close(); });
    img.addEventListener('click',e=>{ e.stopPropagation(); img.classList.toggle('zoomed'); });
    document.addEventListener('keydown',e=>{ if(e.key==='Escape') close(); });
    window.openLightbox=src=>{ img.src=src; img.classList.remove('zoomed'); lb.classList.add('open'); document.body.style.overflow='hidden'; };
  }
  function initTilt(){
    const fine=window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    document.querySelectorAll('[data-tilt]').forEach(el=>{
      if(el._t) return; el._t=1; const src=()=>{const i=el.querySelector('img');return i?i.src:'';};
      el.addEventListener('click',()=>window.openLightbox&&window.openLightbox(src()));
      if(!fine) return; let raf=0;
      el.addEventListener('pointermove',e=>{ const r=el.getBoundingClientRect(); const px=(e.clientX-r.left)/r.width-.5, py=(e.clientY-r.top)/r.height-.5;
        if(raf) return; raf=requestAnimationFrame(()=>{ raf=0; el.style.transform=`perspective(900px) rotateY(${px*9}deg) rotateX(${-py*9}deg) scale(1.035)`; const i=el.querySelector('img'); if(i) i.style.transform=`translate(${px*-8}px,${py*-8}px)`; }); });
      el.addEventListener('pointerleave',()=>{ el.style.transform=''; const i=el.querySelector('img'); if(i) i.style.transform=''; });
    });
  }
  window.initTilt = initTilt;

  /* showcase restart on scroll-in */
  function initShowcase(){
    const sc=document.querySelector('.showcase-embed'); if(!sc || !('IntersectionObserver' in window)) return; let seen=false;
    new IntersectionObserver(es=>es.forEach(e=>{ if(e.isIntersecting&&!seen){seen=true;try{sc.contentWindow.postMessage('ya-restart','*');}catch(_){}} else if(!e.isIntersecting){seen=false;} }),{threshold:0.4}).observe(sc);
  }

  /* ===== PDP variant picker + gallery ===== */
  var GRADE_DESC={
    'Premium':S.grade_premium||'Brand new / open box — never used. Indistinguishable from new.',
    'Excellent':S.grade_excellent||'Near-flawless — no visible marks at arm’s length.',
    'Good':S.grade_good||'Light cosmetic wear visible on close inspection. Great value.',
    'Fair':S.grade_fair||'More visible marks, but screen intact and fully functional. Smartest price.'
  };
  function initProductForm(){
    const form=document.querySelector('form[data-product-form]'); if(!form) return;
    const dataEl=form.querySelector('[data-variants]'); let variants=[]; try{ variants=JSON.parse(dataEl.textContent); }catch(_){}
    const capsEl=form.querySelector('[data-variant-caps]'); try{ window.__yaCaps=JSON.parse(capsEl.textContent); }catch(_){ window.__yaCaps={}; }
    const idInput=form.querySelector('[data-variant-id]');
    const priceEl=document.querySelector('[data-price]'), compareEl=document.querySelector('[data-compare]'), saveEl=document.querySelector('[data-save]');
    const gradeEl=form.querySelector('[data-gradedesc]');
    const condOpt=form.querySelector('[data-cond-opt]');
    const submit=form.querySelector('button[type="submit"]');
    function selected(){
      const opts=[...form.querySelectorAll('input[type="radio"]:checked')].map(r=>r.value);
      return variants.find(v=>{ for(let i=0;i<opts.length;i++){ if(v.options[i]!==opts[i]) return false; } return true; }) || variants[0];
    }
    // Sum of Globo "Add Price" options currently selected — via Globo's hidden properties[...] mirrors
    // (the exact values submitted to cart) so the PDP price matches what the Cart Transform will charge.
    function addonCents(){
      let sum=0;
      form.querySelectorAll('input[type="hidden"][data-addon-price]').forEach(function(el){
        var p=parseFloat(el.getAttribute('data-addon-price'))||0;
        if(p>0 && el.value!=='' && el.value!=null) sum+=p;
      });
      return Math.round(sum*100);
    }
    function update(){
      const v=selected(); if(!v) return;
      idInput.value=v.id;
      const poa = v.price>=999900; // 9999 placeholder = no real price
      const wrap = priceEl ? priceEl.closest('.pdp__price') : null;
      if(wrap) wrap.classList.toggle('is-poa', poa);
      if(priceEl) priceEl.textContent = poa ? (S.price_on_request||'Price on request') : money(v.price + addonCents());
      if(compareEl) compareEl.textContent = (!poa && v.compare_at_price>v.price) ? money(v.compare_at_price) : '';
      if(saveEl) saveEl.textContent = (!poa && v.compare_at_price>v.price) ? (S.save||'Save')+' '+Math.round((v.compare_at_price-v.price)*100/v.compare_at_price)+'%' : '';
      if(submit){
        // Only Shopify's own availability counts as sold out. We used to also flip to "Sold out"
        // whenever this browser's own cart held the last unit — customers who added to cart, then
        // came back to the product page, saw "Sold out" and assumed the site had glitched or
        // oversold them, and abandoned. Shopify's checkout already blocks real overselling at
        // payment time, so this extra check was only producing false "Sold out" labels.
        const sold=!v.available;
        submit.disabled=sold; submit.textContent=sold?(S.sold_out||'Sold out'):(S.add_to_cart||'Add to cart');
      }
      if(gradeEl && condOpt){
        var chk=condOpt.querySelector('input[type="radio"]:checked');
        var g=chk?chk.value:'';
        var txt=GRADE_DESC[g]||'';
        gradeEl.innerHTML = txt ? (txt+' <a href="/pages/certified-renewed" class="gradedesc__link">All grades →</a>') : '';
      }
      syncVariantAvail();
    }
    // Cascade availability: an option value is "available" if some AVAILABLE variant has it together
    // with the values already chosen for the EARLIER options in the funnel (non-condition options
    // first, Condition/Grade always last); later options are left free. Catalog option order is
    // inconsistent, so the funnel is derived from [data-cond-opt], not the product's option positions.
    function syncVariantAvail(){
      if(!CFG.uvFlag && CFG.uvClick && !CFG.uvHide) return;
      const names=[...new Set([...form.querySelectorAll('input[type="radio"]')].map(r=>r.name))];
      const cur={}; names.forEach(n=>{ const c=form.querySelector('input[name="'+n+'"]:checked'); cur[n]=c?c.value:null; });
      let condName=null; const cc=form.querySelector('[data-cond-opt] input[type="radio"]'); if(cc) condName=cc.name;
      const funnel=names.filter(n=>n!==condName); if(condName) funnel.push(condName);
      funnel.forEach((n,fi)=>{
        const oi=parseInt(n.replace('option',''),10)-1; if(isNaN(oi)) return;
        const earlier=funnel.slice(0,fi);
        form.querySelectorAll('input[name="'+n+'"]').forEach(radio=>{
          const ok=variants.some(vt=>{
            if(!vt.available || vt.options[oi]!==radio.value) return false;
            for(const m of earlier){ const mi=parseInt(m.replace('option',''),10)-1; if(cur[m]!=null && vt.options[mi]!==cur[m]) return false; }
            return true;
          });
          const chip=radio.closest('.chip'); if(!chip) return;
          // Hide mode: drop sold-out option chips entirely (never hide the current selection).
          if(CFG.uvHide && !ok && !chip.classList.contains('on')){ chip.classList.add('chip--gone'); radio.disabled=true; return; }
          chip.classList.remove('chip--gone');
          chip.classList.toggle('chip--unavail', CFG.uvFlag && !ok);
          const block=!ok && !CFG.uvClick;
          radio.disabled=block; chip.classList.toggle('chip--noclick', block);
        });
      });
    }
    form.querySelectorAll('input[type="radio"]').forEach(r=>r.addEventListener('change',()=>{
      const lab=r.closest('.chips'); if(lab){ lab.querySelectorAll('.chip').forEach(c=>c.classList.remove('on')); r.closest('.chip').classList.add('on'); }
      update();
    }));
    // Globo adds/removes its hidden add-on mirrors asynchronously → observe the form and recompute the price.
    new MutationObserver(function(){ clearTimeout(window.__gpoPriceT); window.__gpoPriceT=setTimeout(update,30); }).observe(form,{childList:true,subtree:true});
    window.yaSyncPDP=update;            // let the cart layer re-sync the button after add / bfcache
    update();
    if(typeof refreshCart==='function') refreshCart(false); // reflect items already in the cart
  }
  function initGallery(){
    document.querySelectorAll('[data-thumb]').forEach(btn=>btn.addEventListener('click',()=>{
      const main=document.getElementById('pdpMainImg'); if(main) main.src=btn.dataset.thumb;
      document.querySelectorAll('[data-thumb]').forEach(b=>b.classList.remove('on')); btn.classList.add('on');
    }));
  }


  /* ===== Autoplay (muted) videos when scrolled into view ===== */
  function initInviewVideo(){
    var vids=document.querySelectorAll('video[data-inview-video]');
    if(!vids.length||!('IntersectionObserver' in window)) return;
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        var v=e.target;
        if(e.isIntersecting){ var p=v.play(); if(p&&p.catch)p.catch(function(){}); }
        else if(!v.paused){ v.pause(); }
      });
    },{threshold:0.5});
    vids.forEach(function(v){ io.observe(v); });
  }

  function initTabs(){
    document.querySelectorAll('[data-ya-tabs]').forEach(function(w){
      var tabs=w.querySelectorAll('.ya-tabs__tab'), panels=w.querySelectorAll('.ya-tabs__panel');
      tabs.forEach(function(t){ t.addEventListener('click',function(){
        var k=t.getAttribute('data-ya-tab');
        tabs.forEach(function(x){x.classList.remove('on');}); t.classList.add('on');
        panels.forEach(function(p){p.classList.toggle('on',p.getAttribute('data-ya-panel')===k);});
      });});
    });
  }

  // Predictive suggestions for the visible header search bar(s)
  function initSearchBar(){
    document.querySelectorAll('[data-ya-searchbar]').forEach(form=>{
      const input=form.querySelector('input[name="q"]'), drop=form.querySelector('[data-ya-search-drop]');
      if(!input||!drop) return; let t;
      async function draw(q){
        q=q.trim(); if(q.length<2){ drop.innerHTML=''; drop.hidden=true; return; }
        try{
          const u=(R.predictive_search_url||'/search/suggest')+'.json?q='+encodeURIComponent(q)+'&resources[type]='+YA_SEARCH_TYPES+'&resources[limit]=4&resources[limit_scope]=each';
          const r=await fetch(u); const j=await r.json(); const groups=ySearchGroups(j);
          if(!groups.length){ drop.innerHTML='<div class="ya-searchbar__none">'+((S.search_no_results||'No matches for “{{ terms }}”.').replace('{{ terms }}',q))+'</div>'; drop.hidden=false; return; }
          drop.innerHTML=ySearchBarHTML(groups);
          drop.hidden=false;
        }catch(_){ drop.hidden=true; }
      }
      input.addEventListener('input',()=>{ clearTimeout(t); t=setTimeout(()=>draw(input.value),140); });
      input.addEventListener('focus',()=>{ if(input.value.trim().length>=2) draw(input.value); });
      input.addEventListener('keydown',e=>{ if(e.key==='Escape') drop.hidden=true; });
      document.addEventListener('click',e=>{ if(!form.contains(e.target)) drop.hidden=true; });
    });
  }
  document.addEventListener('DOMContentLoaded',()=>{ initSlideshow(); initDrawer(); initFAQ(); initCart(); initSearch(); initSearchBar(); initLightbox(); initTilt(); initShowcase(); initProductForm(); initGallery(); initInviewVideo(); initTabs(); initCartPageOpts(); initCartPage(); });
})();

/* ===== Yes Check showcase ===== */
(function(){
  var root=document.querySelector('.yescheck'); if(!root) return;
  var SCENES=[{id:"sc0",label:"AI grading",dur:4800},{id:"sc1",label:"Disassembly",dur:4000},{id:"sc2",label:"Testing",dur:5400,on:runCounter},{id:"sc3",label:"Anodising",dur:4400},{id:"sc4",label:"Reassembly",dur:4000},{id:"sc5",label:"Certified",dur:5200}];
  var CATS=["Display & touch","Battery health","Cameras & sensors"];
  var tf=document.getElementById("yc-testfeat"); if(tf) tf.innerHTML=CATS.map(function(c){return '<li><span class="d"></span>'+c+'</li>';}).join("");
  var chapters=document.getElementById("yc-chapters"),fill=document.getElementById("yc-fill");
  SCENES.forEach(function(s,i){var c=document.createElement("div");c.className="yc-ch";c.textContent=(i+1)+". "+s.label;c.onclick=function(){jump(i);};chapters.appendChild(c);});
  var chEls=[].slice.call(chapters.children);
  var SI=0,playing=true,timers=[],ct=[];
  function clearTimers(){timers.forEach(clearTimeout);timers=[];}
  function T(fn,ms){var id=setTimeout(fn,ms);timers.push(id);return id;}
  function runCounter(){ct.forEach(clearTimeout);ct=[];var el=document.getElementById("yc-count");var n=0,tgt=489;
    (function tick(){n+=Math.ceil((tgt-n)/14)||1;if(n>tgt)n=tgt;el.textContent=n;if(n<tgt)ct.push(setTimeout(tick,55));})();}
  function showScene(i){SI=i;SCENES.forEach(function(s,k){document.getElementById(s.id).classList.toggle("active",k===i);});
    chEls.forEach(function(c,k){c.classList.toggle("active",k===i);c.classList.toggle("done",k<i);});if(SCENES[i].on)SCENES[i].on();}
  var TOTAL=SCENES.reduce(function(a,s){return a+s.dur;},0);
  function cum(i){var s=0;for(var k=0;k<i;k++)s+=SCENES[k].dur;return s;}
  function run(i){clearTimers();showScene(i);
    var startPct=cum(i)/TOTAL*100,endPct=cum(i+1)/TOTAL*100;
    fill.style.transition="none";fill.style.width=startPct+"%";void fill.offsetWidth;
    fill.style.transition="width "+SCENES[i].dur+"ms linear";fill.style.width=endPct+"%";
    T(function(){if(i<SCENES.length-1)run(i+1);},SCENES[i].dur);}
  function jump(i){playing=true;document.getElementById("yc-pp").textContent="❚❚";run(i);}
  function pause(){playing=false;clearTimers();ct.forEach(clearTimeout);var w=getComputedStyle(fill).width;fill.style.transition="none";fill.style.width=w;document.getElementById("yc-pp").textContent="▶";}
  function play(){playing=true;document.getElementById("yc-pp").textContent="❚❚";run(SI);}
  document.getElementById("yc-pp").onclick=function(){playing?pause():play();};
  document.getElementById("yc-rp").onclick=function(){jump(0);};
  run(0);
  if('IntersectionObserver' in window){var seen=false;
    new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting&&!seen){seen=true;jump(0);} else if(!e.isIntersecting){seen=false;} });},{threshold:0.4}).observe(root);}
})();
